import React from 'react';

import styled from 'styled-components';
import { Form, Radio, Input } from 'antd';

import { useImmerAtom } from 'jotai-immer';
import * as Constants from '../../views/diagnosis/constants';
import { diagnosisBaseAtom } from './atom';
import { useHandleEventValue } from './hooks';

export default function Index({ getFieldDecorator, radioButtonMessage, inputMessage }) {
  const [, setDiagnosisBase] = useImmerAtom(diagnosisBaseAtom);
  const handleBaseInfoClick = useHandleEventValue({ setImmerState: setDiagnosisBase });
  return (
    <>
      <Form.Item>
        {getFieldDecorator('relationType', {
          rules: [
            {
              required: true,
              message: radioButtonMessage
            }
          ]
        })(
          <RelayionTypeSection>
            <QueryTitle>식단 드시는 분은 누구인가요?</QueryTitle>
            <Radio.Group buttonStyle="solid">
              {Constants.RELATION_TYPE_OPTIONS.map(item => {
                const { name, value } = item;
                return (
                  <SelectBox key={value} onClick={handleBaseInfoClick('relationType')} value={value}>
                    {name}
                  </SelectBox>
                );
              })}
            </Radio.Group>
          </RelayionTypeSection>
        )}
      </Form.Item>
      <QueryTitle>드시는 분의 기본정보를 입력해주세요</QueryTitle>
      <Section>
        <Form.Item>
          {getFieldDecorator('gender', {
            rules: [
              {
                required: true,
                message: radioButtonMessage
              }
            ]
          })(
            <GenderSection>
              <SubQueryTitle>성별</SubQueryTitle>
              <Radio.Group buttonStyle="solid">
                {Constants.GENDER_OPTIONS.map(item => {
                  const { name, value } = item;
                  return (
                    <SelectBox key={value} onClick={handleBaseInfoClick('gender')} value={value}>
                      {name}
                    </SelectBox>
                  );
                })}
              </Radio.Group>
            </GenderSection>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('bornYear', {
            rules: [
              {
                required: true,
                message: inputMessage
              },
              {
                max: 4,
                message: '4자리 숫자를 입력해주세요. (예:1990)'
              }
            ]
          })(
            <BornYearSection>
              <SubQueryTitle>
                출생년도 <span style={{ color: '#bdbdbd' }}>(예:1990)</span>
              </SubQueryTitle>
              <InputBox name="bornYear" onChange={handleBaseInfoClick('bornYear')} placeholder="예: 1990" suffix="년" maxLength={4} type="number" />
            </BornYearSection>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('height', {
            rules: [
              {
                required: true,
                message: inputMessage
              },
              {
                min: 3,
                message: '3자리 숫자를 입력해주세요. (예:165)'
              }
            ]
          })(
            <HeightSection>
              <SubQueryTitle>키 / 몸무게</SubQueryTitle>
              <InputBox name="height" onChange={handleBaseInfoClick('height')} placeholder="예: 165" suffix="cm" type="number" maxLength={3} />
            </HeightSection>
          )}
        </Form.Item>

        <Form.Item>
          {getFieldDecorator('weight', {
            rules: [
              {
                required: true,
                message: inputMessage
              },
              {
                max: 3
              }
            ]
          })(
            <WeightSection>
              <InputBox name="weight" onChange={handleBaseInfoClick('weight')} placeholder="예: 50" suffix="kg" maxLength="3" type="number" />
            </WeightSection>
          )}
        </Form.Item>
      </Section>
    </>
  );
}

const RelayionTypeSection = styled.div`
  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    font-size: 1.8rem;
    ${props => props.theme.device.md} {
      font-size: 2.4rem;
    }
  }
`;
const QueryTitle = styled.div`
  word-break: keep-all;
  font-size: 2.1rem;
  font-weight: 700;
  color: #323232;
  margin-bottom: 2rem;
  margin-top: 5rem;
  ${props => props.theme.device.md} {
    margin-top: 10rem;
    font-size: 2.9rem;
  }
`;
const SelectBox = styled(Radio.Button)`
  height: 6rem;
  word-break: keep-all;
  margin: 0.5rem 0;
  width: calc(50% - 1.6rem);
  line-height: ${props => (props.lineHight ? '4rem' : '6rem')};
  span {
    font-size: 1.6rem;
  }
  ${props => props.theme.device.md} {
    height: 7.2rem;
    line-height: ${props => (props.lineHight ? '6.5rem' : '7.2rem')};
    span {
      font-size: 2.4rem;
      word-break: keep-all;
    }
  }
`;

const Section = styled.div``;

const GenderSection = styled(RelayionTypeSection)``;

const SubQueryTitle = styled.div`
  word-break: keep-all;
  font-size: 1.8rem;
  font-weight: 400;
  color: #323232;
  margin-bottom: ${props => (props.isText ? '0' : '2rem')};

  ${props => props.theme.device.md} {
    font-size: 2rem;
  }
`;
const BornYearSection = styled(RelayionTypeSection)``;

const InputBox = styled(Input)`
  width: 60%;
  height: 6rem;
  line-height: 6rem;
  font-size: 1.8rem;
  margin-bottom: 1rem;
  input::placeholder {
    font-size: 1.8rem;
  }
  ${props => props.theme.device.md} {
    font-size: 2.4rem;
    height: 7.2rem;
    line-height: 7.2rem;
    input::placeholder {
      font-size: 2.4rem;
    }
  }
`;

const HeightSection = styled(RelayionTypeSection)``;

const WeightSection = styled(RelayionTypeSection)``;
